import { Link } from "react-router-dom";
import type { ReactElement } from "react";

// Catch-all 404 page. The server always answers unknown paths with the SPA
// shell (SPAStaticFiles history fallback), so this route is the only place a
// wrong URL becomes visible — never silently redirect (docs/IRB_WALKTHROUGH.md
// listed the old silent redirect-to-landing as a gap).
export function NotFound(): ReactElement {
  return (
    <div className="full-center">
      <div className="app-card" role="status">
        <h2>Page not found</h2>
        <p className="muted">
          That page doesn't exist. It may have moved, or the link may be wrong.
        </p>
        <Link to="/" className="btn-primary-glow">
          Back to the home page
        </Link>
      </div>
    </div>
  );
}
